<template>
  <v-layout wrap justify-left align-center>
    <v-dialog v-model="dialogExportCaixaGeral" persistent scrollable max-width="600">
      <v-card>
        <v-card-title primary-title>
          <span class="display-1">Gerar Caixa Geral</span>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-form @keyup.native.esc="close" @keyup.native.enter="confirm()">
              <v-flex xs12>
                <v-autocomplete
                  :items="condominiosPessoa"
                  v-model="editedItem.condominios_ids"
                  label="Condominios"
                  multiple
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <p-money label="Saldo Anterior" v-model="editedItem.saldo_anterior"></p-money>
              </v-flex>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confirm">Confirmar</v-btn>
          <v-btn color="green darken-1" flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style scoped>
</style>
<script>
  import PMoney from '../shared/PMoney'

  export default {
    name: 'PExportCaixaGeral',
    components: { PMoney },
    data () {
      return {
        // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
        condominiosPessoa: [],
        dialogExportCaixaGeral: false,
        editedItem: {pessoa_id: '', saldo_anterior: 0, condominios_ids: []}
      }
    },
    methods: {
      confirm () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`report/caixa_geral`, this.editedItem, {responseType: 'arraybuffer'}).then(res => {
          // this.$http.get(`report/caixa_geral/${pessoa_id}`).then(res => {
          console.log('res,', res)
          let blob = new Blob([res.data], {type: res.headers.get('content-type')})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `caixa_geral-${this.editedItem['nome']}-${this.$auth.user().anobase.id_texto + 1}-${parseInt(this.$auth.user().anobase.id_texto)}.pdf`
          link.click()
          this.$store.commit('loader/change_dialog', false)
        }, () => this.$store.commit('loader/change_dialog', false)
        )
      },
      // confirm: function () {
      //   console.log('confirm')
      // },
      close: function () {
        this.dialogExportCaixaGeral = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PExportCaixaGeral.vue